module.exports = __webpack_public_path__ + "static/media/gezichtje.1700bbc3.gif";